import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import "./static-file/css/common.css";
import "./static-file/css/datepick.css";
import LoadingView from "./views/main/body/layer/LoadingView";
import AppRoutes from "routes/routes";

@inject("component")
@inject("rootStore")
@observer
class App extends Component {
  render() {
    const { rootStore } = this.props;
    rootStore.timerStore.startTimer();
    rootStore.timerStore.minTimer();
    return (
      <>
        <AppRoutes />
        <LoadingView rootStore={rootStore} /> {/*로딩*/}
      </>
    );
  }
}

export default App;
